import { render, staticRenderFns } from "./SlideGrafico.vue?vue&type=template&id=e837b2c8&scoped=true&"
import script from "./SlideGrafico.vue?vue&type=script&lang=js&"
export * from "./SlideGrafico.vue?vue&type=script&lang=js&"
import style0 from "./SlideGrafico.vue?vue&type=style&index=0&id=e837b2c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e837b2c8",
  null
  
)

export default component.exports